import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './AddNewFund.scss';

import FundRegistration from '../FundRegistration/FundRegistration';
import NewFundSearch from '../NewFundSearch/NewFundSearch';
import Loader from '../../Shared/Loader/Loader';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import {
  isCollegeExchange,
  isExchange,
} from '../../../utils/transactions-util';
import { getBucketRoll } from '../../../redux/modules/bucketRoll/bucketRoll.selectors';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';

export class AddNewFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      currentStep: isCollegeExchange()
        ? 'FUND_SEARCH'
        : isExchange()
        ? 'LOADING'
        : 'REGISTRATION',
    };
  }

  componentDidMount() {
    const {
      actions: { searchExchangeToNew },
      exchangeFromFirstFund,
    } = this.props;
    if (exchangeFromFirstFund) {
      searchExchangeToNew(exchangeFromFirstFund);
    }
  }

  componentDidUpdate(prevProps) {
    const { exchangeToNewLoading } = this.props;
    if (prevProps.exchangeToNewLoading && !exchangeToNewLoading) {
      this.setFundProgress('FUND_SEARCH');
    }
  }

  setFundProgress = (step) => {
    this.setState({ currentStep: step });
  };

  render() {
    const {
      customerWebViewEnabled,
      isSalesforceRep,
      dispatchPageLoad,
      actions,
      bucketRoll,
      personalInformation,
      IRALimit,
      addFunds,
      modalProps,
      selectedBankAssociableOrAssociatedLookup,
      shoppingCart,
      userProductTypes,
      userRegistrationTypeInfo,
      actions: { setRegistrationTypes },
      availableFundList,
      exchangeToNewLoading,
    } = this.props;
    const personalData = personalInformation.data;
    const { currentStep } = this.state;
    const LOADING = 'LOADING';
    const REGISTRATION = 'REGISTRATION';
    const FUND_SEARCH = 'FUND_SEARCH';

    return (
      <Switch test={currentStep}>
        <Case value={LOADING}>
          <Loader innerClassName="add-new0fund-loader" isVisible />
        </Case>
        <Case value={REGISTRATION}>
          <FundRegistration
            customerWebViewEnabled={customerWebViewEnabled}
            isSalesforceRep={isSalesforceRep}
            actions={actions}
            availableFundList={availableFundList}
            bucketRoll={bucketRoll}
            personalData={personalData}
            IRALimit={IRALimit}
            dispatchPageLoad={dispatchPageLoad}
            modalProps={modalProps}
            selectedBankAssociableOrAssociatedLookup={
              selectedBankAssociableOrAssociatedLookup
            }
            setRegistrationTypes={setRegistrationTypes}
            setFundProgress={this.setFundProgress}
            userProductTypes={userProductTypes}
            userRegistrationTypeInfo={userRegistrationTypeInfo}
          />
        </Case>
        <Case value={FUND_SEARCH}>
          <NewFundSearch
            dispatchPageLoad={dispatchPageLoad}
            shoppingCart={shoppingCart}
            addFunds={addFunds}
            actions={actions}
            availableFundList={availableFundList}
            exchangeToNewLoading={exchangeToNewLoading}
            modalProps={modalProps}
            setFundProgress={this.setFundProgress}
            userRegistrationTypeInfo={userRegistrationTypeInfo}
          />
        </Case>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    allFunds,
    IRALimit,
    personalInformation,
    routing,
    shoppingCart,
    userProductTypes,
  } = state;
  return {
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    allFunds,
    bucketRoll: getBucketRoll(state),
    IRALimit,
    personalInformation,
    routing,
    shoppingCart,
    userProductTypes,
  };
};

export default compose(connect(mapStateToProps))(AddNewFund);
